<template>
  <div class="breadcrumb-container" v-show="show">
    <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb-inner">
      <transition-group name="breadcrumb">
        <el-breadcrumb-item v-for="(item, index) in breadcrumbs" :key="item.path" class="item">
          <div v-if="item.meta?.noView">
            <a style="cursor:default;">{{ item.meta.title || '' }}</a>
          </div>
          <div v-else>
            <img v-if="item.src" :src=item.src alt="" @click.prevent="handleLink(item)" style="cursor: pointer;">

            <a v-else @click.prevent="handleLink(item)" style="cursor: pointer;">
              {{ item.meta.title || '' }}
            </a>
          </div>

        </el-breadcrumb-item>
      </transition-group>
    </el-breadcrumb>
  </div>
</template>

<script>
import {getPumpList, downloadFile} from "@/api";
import i18n from "@/i18n";

export default {
  name: 'Breadcrumb',
  props: {
    isDetailNews:{
      type: Boolean,
      default: false
    },
    isDetailProduct: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      breadcrumbs: [],
      eletricName: '',
      lastName: '',
      routeType: null,
      show: false
    }
  },

  watch: {
    $route() {
      this.routeType = this.$route.query.type
      console.log(this.$route.query.type)
      this.getBreadcrumb()
      this.fetchPumpList(this.routeType)
    },
    type: {
      handler(val) {

        getPumpList().then(res => {
          let item = res.data.find(item => item.type == val)
          this.lastName = item?.name
          this.eletricName = res.data.find(item => item.type == 1).name
          this.getBreadcrumb()
        })
      },
      immediate: true
    }
  },
   created() {
     this.getBreadcrumb()

  },
  methods: {
    getBreadcrumb() {
      // 获取匹配的路由记录
      // let matched = this.$route.matched出现路由不跳转问题
      // ============修改matched时将路由配置也修改了，导致找不到匹配的路由

      // let matched = JSON.parse(JSON.stringify(this.$route.matched))
      // 出现问题 Error in created hook: "TypeError: Converting circular structure to JSON
      // --> starting at object with constructor 'VueComponent'
      // |     property '_scope' -> object with constructor 'EffectScope'
      // |     property 'effects' -> object with constructor 'Array'
      // |     index 0 -> object with constructor 'Watcher'
      // --- property 'vm' closes the circle"
      //这个错误是因为 this.$route.matched 包含循环引用（circular reference），无法直接使用 JSON.stringify() 序列化。在 Vue Router 的路由对象中，通常包含对 Vue 组件实例的引用，这些引用会形成循环结构。

      const matched = this.$route.matched.map(route => ({
        path: route.path,
        name: route.name,
        meta: route.meta ? {...route.meta} : {}
      }))
      // console.log('getBreadcrumb-$route', this.$route)
      console.log('matched', matched)
      // 第一个路由为首页
      const first = matched[0]
      if (first && first.name !== 'Index') {
        matched[0] = {
          path: '/index',
          meta: {title: ''},
          src: require('@/assets/images/home.svg')
        }
      }
      if (this.isDetailProduct) {
        let index = matched.length - 1

        matched[index].meta.title = this.lastName

        let eletricPump = {
          path: "/productService/product/lifting/electricPump",
          meta: {title:  this.eletricName},
          name: 'ElectricPump',
        }
        //  将eletricPump插入到matched数组倒数第二个
        matched.splice(index, 0, eletricPump)
      }
      if(this.isDetailNews){
        let index = matched.length - 1

        let news = {
          path: '/news',
          name: 'News',
          meta: {title: i18n.t('xin-wen-zhong-xin')}//新闻中心

        }
        //  将eletricPump插入到matched数组倒数第二个
        matched.splice(index, 0, news)
      }
      this.breadcrumbs = matched

      this.show = true
      // console.log('this.breadcrumbs', this.breadcrumbs)
    },

    handleLink(item) {
      if (!item.hidden) {
        this.$router.push(item.path)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.breadcrumb-container {
  display: inline-block;
  font-size: 14px;
  line-height: 50px;
  margin-left: 8px;

  padding-left: 10%;
  padding-right: 10%;
}

@media (max-width: 1024px) {
  .breadcrumb-container {
    padding-left: 14px;
    padding-right: 14px;
    display: none;
  }
}

.breadcrumb-inner {
  display: inline-block;
}

::v-deep .el-breadcrumb__item {
  display: flex;
  align-items: center;

  img {
    width: 24px;
    height: 24px;
  }

  .el-breadcrumb__separator {
    font-size: 20px;
    margin: 0 6px;
  }

  .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link {
    color: #999;
    font-family: "Alibaba PuHuiTi";
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;

    &:hover {
      color: #1C277F;
    }
  }
}

.breadcrumb-enter-active,
.breadcrumb-leave-active {
  transition: all .5s;
}

.breadcrumb-enter,
.breadcrumb-leave-active {
  opacity: 0;
  transform: translateX(20px);
}

.breadcrumb-leave-active {
  position: absolute;
}
</style>
